const colors = ['', '#FB1808', '#FEEF0B', '#30FF07', '#1DE5FE', '#0031FF', '#FB00E3', '#FB001F', '#FB1808', '#FEEF0B', '#30FF07', '#1DE5FE', '#0031FF', '#FB00E3']

class Draw {
  constructor(obj, setting) {
    this.obj = obj

    this.updateInit(setting)
    this.updateLineWidth(setting.lineWidth)
  }

  updateInit = (setting) => {
    this.obj.lineCap = 'round'
    this.obj.lineJoin = 'round'

    this.styleType = setting.styleType || 'stroke'
    this.color = setting.color || '#000'
    this.screenWidth = setting.screenWidth || 300
    this.screenHeight = setting.screenHeight || 150
    this.rainbow = setting.rainbow
    this.obj.strokeStyle = this.color
    this.obj.fillStyle = this.color
  }

  updateLineWidth = (lineWidth) => {
    this.lineWidth = lineWidth
    this.obj.lineWidth = lineWidth || 1
  }

  rect = (x, y, x1, y1) => {
    this.obj.beginPath()
    this.obj.rect(x, y, x1 - x, y1 - y)
    if (this.styleType === 'stroke') {
      this.obj.stroke()
    } else if (this.styleType === 'fill') {
      this.obj.fill()
    }
  }

  line = (x, y, x1, y1) => {
    this.obj.beginPath()
    this.obj.moveTo(x, y)
    this.obj.lineTo(x1, y1)
    this.obj.stroke()
  }

  circle = (x, y, x1, y1) => {
    const r = Math.sqrt(Math.pow(x - x1, 2) + Math.pow(y - y1, 2))
    this.obj.beginPath()
    this.obj.arc(x, y, r, 0, 2 * Math.PI)
    if (this.styleType === 'stroke') {
      this.obj.stroke()
    } else if (this.styleType === 'fill') {
      this.obj.fill()
    }
  }

  poly = (x, y, x1, y1, n) => {
    const r = Math.sqrt(Math.pow(x - x1, 2) + Math.pow(y - y1, 2))
    this.obj.save()
    this.obj.translate(x, y)
    this.obj.rotate(Math.PI / 2)
    const nx = r * Math.cos(Math.PI / n)
    const ny = r * Math.sin(Math.PI / n)
    this.obj.beginPath()
    this.obj.lineCap = 'round'
    this.obj.moveTo(nx, ny)
    for (let i = 0; i <= n; i++) {
      this.obj.rotate(Math.PI * 2 / n)
      this.obj.lineTo(nx, -ny)
    }
    if (this.styleType === 'stroke') {
      this.obj.stroke()
    } else if (this.styleType === 'fill') {
      this.obj.fill()
    }
    this.obj.restore()
  }

  linearGradient = () => {
    this.canvasGradient = this.obj.createLinearGradient(0, 0, this.screenWidth, this.screenHeight)
    colors.forEach((item, index) => {
      if (item) {
        this.canvasGradient.addColorStop(index / colors.length, item)
      }
    })
    // 将strokeStyle的属性设置为该CanvasGradient对象
    this.obj.strokeStyle = this.canvasGradient
  }

  pen = (x, y, x1, y1) => {
    if (this.rainbow) {
      this.linearGradient()
    }
    this.obj.save()
    this.obj.quadraticCurveTo(x, y, x1, y1);
    this.obj.stroke()
    this.obj.closePath()
  }

  eraser = (x, y, x1, y1) => {
    this.obj.clearRect(x1 - 5, y1 - 5, 10, 10)
  }

  cut = (x, y, x1, y1) => {
    this.init()
    this.obj.save()
    this.obj.setLineDash([4, 2])
    this.obj.beginPath()
    this.obj.lineWidth = 1
    this.obj.rect(x, y, x1 - x, y1 - y)
    this.obj.stroke()
    this.obj.restore()
  }
}

export default Draw



// WEBPACK FOOTER //
// ./src/utils/draw.js